import { asSelectable } from 'options/selectable';

const MULTI_RACE = asSelectable('M', 'Multi-Race');

export { MULTI_RACE };
